import { createSelector } from '@reduxjs/toolkit'
import { landingPageThemeApi } from 'api/landingPageTheme'
import { selectApp } from './app'

// Selector to get the theme ID from the landing page theme API
export const selectThemeId = createSelector(
  [selectApp, state => state],
  (app, state) => {
    if (!app?.id) return null

    const queryResult =
      landingPageThemeApi.endpoints.getLandingPageTheme.select(app.id)(state)
    return queryResult?.data?.app_landing_page_theme?.id || null
  }
)
